export default __webpack_public_path__ + "static/media/right.25c07c65.svg";